var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flatServerErrors && _vm.flatServerErrors.length)?_c('ul',{staticClass:"server-errors",attrs:{"role":"alert"}},_vm._l((_vm.flatServerErrors),function(error){return _c('li',{key:error},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }